/**
 * Request options for the factory's API modules (projects, runs, machines, secrets, admin).
 * Not an API module itself: it only builds the RequestInit that `fetchApi` takes.
 */

/** The header project-scoped routes read: a project id or slug (docs/first-slice-plan.md §2). */
export const PROJECT_HEADER = 'X-Project-Id';

export interface FactoryRequestOptions {
  signal?: AbortSignal;
  /**
   * The project (id or slug) for a project-scoped route. Inside a `/p/:slug` page fetchApi adds the
   * header itself; pass it to name the project explicitly (a page that knows its slug, a dialog
   * opened outside the project's routes).
   */
  project?: string;
}

/** fetchApi's options for a call: method, JSON body, abort signal and the project header. */
export function factoryInit(opts: FactoryRequestOptions = {}, method?: string, body?: unknown): RequestInit {
  const init: RequestInit = {};
  if (method) init.method = method;
  if (body !== undefined) init.body = JSON.stringify(body);
  if (opts.signal) init.signal = opts.signal;
  if (opts.project) init.headers = { [PROJECT_HEADER]: opts.project };
  return init;
}

/** `?a=1&b=2` from the defined values, or '' when there are none. */
export function queryString(params: Record<string, string | number | null | undefined>): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== '') search.set(key, String(value));
  }
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}
